import { useRequiredParams } from '@pba/react-router';
import {
  GroupAnnouncementsGuard,
  GroupDetailAnnouncements,
  GroupDetailAnnouncementsHeader,
  GroupLayout,
} from 'features/groups';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToGroupDetailPageByKey } from '../hooks';

const PageGroupDetailAnnouncements = () => {
  const { groupId } = useRequiredParams<{ groupId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigateToGroupDetailPageByKey = useNavigateToGroupDetailPageByKey();

  return (
    <GroupLayout
      groupId={groupId}
      header={(group) => (
        <GroupAnnouncementsGuard
          group={group}
          navigateToGroupDetailPageByKey={navigateToGroupDetailPageByKey}
          scope="announcements"
        >
          <GroupDetailAnnouncementsHeader
            group={group}
            navigateToGroupDetailPageByKey={navigateToGroupDetailPageByKey}
          />
        </GroupAnnouncementsGuard>
      )}
    >
      {(group) => (
        <GroupAnnouncementsGuard
          group={group}
          navigateToGroupDetailPageByKey={navigateToGroupDetailPageByKey}
          scope="announcements"
        >
          <GroupDetailAnnouncements getPathToEntityDetail={getPathToEntityDetail} group={group} />
        </GroupAnnouncementsGuard>
      )}
    </GroupLayout>
  );
};

export default PageGroupDetailAnnouncements;
